import "@/icons"; // icon
import "@/permission"; // permission control
import "@/styles/element-variables.scss";
import "@/styles/index.scss"; // global css
import ElementUI from "element-ui";
import Cookies from "js-cookie";
import "normalize.css/normalize.css"; // A modern alternative to CSS resets
import Vue from "vue";
import App from "./App";
import * as filters from "./filters"; // global filters
import router from "./router";
import store from "./store";
import "@/utils/error-log"; // error log
import {loading,borderBox13,digitalFlop,capsuleChart,borderBox8,borderBox12,borderBox1,borderBox9,borderBox10,decoration9,scrollBoard} from '@jiaminghi/data-view'
import { initializeDuerSDK } from '@/utils/duerService';
import IncomingCallDialogPlugin from '@/utils/IncomingCallDialog';
import callViewDialogPlugin from "@/utils/callView";
import  makingCallDialogPlugin  from '@/utils/makingCall';
import "vue-easytable/libs/theme-default/index.css";
import  '@/assets/css/public.scss'
import '@/assets/iconfont/iconfont.css';
import ItemWrap from './components/item-wrap/item-wrap.vue'
import Echart from './components/echart/index.vue'

Vue.use(IncomingCallDialogPlugin);
Vue.use(callViewDialogPlugin);
Vue.use(makingCallDialogPlugin);
Vue.component("ItemWrap",ItemWrap)
Vue.component("Echart",Echart)

// datav组件
Vue.use(loading)
Vue.use(borderBox13)
Vue.use(borderBox8)
Vue.use(digitalFlop)
Vue.use(capsuleChart)
Vue.use(borderBox12)
Vue.use(borderBox1)
Vue.use(borderBox9)
Vue.use(borderBox10)
Vue.use(decoration9)
Vue.use(scrollBoard)
ElementUI.Dialog.props.lockScroll.default = false
/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */
// if (process.env.NODE_ENV === "production") {
//   const { mockXHR } = require("../mock");
//   mockXHR();
// }
// set ElementUI lang to EN
//Vue.use(ElementUI, { locale })
// 如果想要中文版 elemet-ui，按如下方式声明
Vue.use(ElementUI, {
  size: Cookies.get("size") || "default", // set element-ui default size
});

Vue.directive('removeAriaHidden', {
  bind(el, binding) {
    const ariaEls = el.querySelectorAll('.el-radio__original')
    ariaEls.forEach((item) => {
      item.removeAttribute('aria-hidden')
    })
  }
})


// register global utility filters
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});
Vue.config.productionTip = false;

// 创建事件总线
Vue.prototype.$bus = new Vue()

Vue.config.productionTip = false;
// 初始化 DUER SDK
initializeDuerSDK()
  .then(() => {
    new Vue({
      router,
      store,
      render: h => h(App),
    }).$mount('#app');
  })
  .catch((error) => {
    console.error('DUER SDK 初始化失败:', error);
  });

//new Vue({
//  el: "#app",
//  router,
//  store,
//  render: (h) => h(App),
//});
